import { useSyncExternalStore } from 'react'

let waking = false
const listeners = new Set<() => void>()

/** Set by the Axios interceptor: true on 503 DATABASE_WAKING, false on the next success. */
export function setDatabaseWaking(value: boolean) {
  if (waking === value) return
  waking = value
  listeners.forEach((fn) => fn())
}

function subscribe(fn: () => void) {
  listeners.add(fn)
  return () => { listeners.delete(fn) }
}

export function useDatabaseWaking(): boolean {
  return useSyncExternalStore(subscribe, () => waking)
}
